export default __webpack_public_path__ + "background.484f2690739180c355a3421500ab2641.jpg"